export { VueBrowserPlatformProvider } from './vue-browser-platform-provider';
export { DingTalkPlatformProvider } from './ding-talk-platform-provider';
export { IosPlatformProvider } from './ios-platform-provider';
export { WeChatOfficialPlatformProvider } from './wechat-official-platform-provider';
export { AndroidPlatformProvider } from './android-platform-provider';

// eslint-disable-next-line no-shadow
export enum DownloadType {
  /**
   * 下载
   */
  DOWNLOAD = 'DOWNLOAD',
  /**
   * 后台导出
   */
  BACKEND_EXPORT = 'BACKEND_EXPORT',
  /**
   * 前台导出
   */
  FRONT_EXPORT = 'FRONT_EXPORT',
}
